<div class="scad-drag-area">
    <div class="scad-drag-area__body">
      <div class="scad-drag-area__wrapper">
        <div class="scad-drag-area__drag-section">
          <div class="scad-drag-area__drag-actoin">
            <!-- <div><img src="assets/images/svg/square.svg" alt="" /></div>
            <div><img src="assets/images/svg/star.svg" alt="" /></div> -->
            <div class="disable"><img src="assets/images/svg/undo.svg" alt="" /></div>
            <div class="redo disable"><img src="assets/images/svg/undo.svg" alt="" /></div>
            <div><img src="assets/images/svg/tick.svg" alt="" /></div>
            <div class="scad-test-flow__action">
              <img src="assets/images/svg/save.svg" alt="" />
            </div>


            <!-- <button class="scad-drop-btn-secondary" [matMenuTriggerFor]="menu"> -->
            <button class="scad-drop-btn-secondary" [matMenuTriggerFor]="menu">
              <span class="arrow"><img src="/assets/images/svg/play.svg" alt="" /> </span>
              <span
                ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.66669 6.66663L9.9333 13.3333L15.1429 6.66663" stroke="#CCDDF1" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  </span>
            </button>
            <mat-menu #menu="matMenu" class="sh-dropdown-menu">
                <!-- <li mat-menu-item  (click)="saveFlowbuilder()" class="p-0 sh-dropdown-menu__item"><span>Run</span></li> -->
                <div class="run-modal" (click)="$event.stopPropagation()">
                  <label  for="">Maximum Sample Size</label>
                  <input type="number" name="" id="" [min]="5" (change)="sampleValueRestrit()"   [(ngModel)]="_flowBuilder.sampleSize">
                </div>
                <div class="scad-read-tab__tab" [class.active]="" (click)="saveFlowbuilder()"> Run
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M11.5421 5.83334L16.211 10.4885L11.4868 15.2265" stroke="#1847DF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4 10.53H16.2111" stroke="#1847DF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <!-- <button class="scad-btn scad-btn--primary">Test Connection</button> -->
            </mat-menu>

          </div>
          <!-- [ngStyle]="{scale: flowScale}" -->
          <div id="drawflow"   #drawflow (dragover)="_flowBuilder.onDragOver($event)" (drop)="_flowBuilder.onDrop($event)" (click)="dataToRunApi('set')">
          </div>
        </div>
        <app-flow-right-section [hidden]="!_flowBuilder.showSettings"></app-flow-right-section>

      </div>
  </div>



  <!--
        <div class="scad-drag-area__drag-scroll "> <img src="/assets/images/svg/drow.svg" alt="" /> </div>
        <div class="scad-drag-area__btn scad-drag-area__source" style="top: 100px; left: 50px;"> <img src="/assets/images/svg/sub-menu-2.svg" alt="" /> </div>
            <div class="box scad-drag-area__btn scad-drag-area__target " style="left: 200px; top: 100px;" >
              <div class="scad-drag-area__btn scad-drag-area__target-color">
                <img src="/assets/images/svg/tabler_filter.svg" alt="" />
              </div>
            </div>

            <div class="scad-drag-area__tooltip" style="left: 200px; top: 100px;"> source-name </div>

          </div> -->


